import {
  type BulkActionQueries,
  defBulkActionQueries,
} from '@kizen/query/bulk-actions';

import AxiosService from 'services/AxiosService';

const queries: BulkActionQueries = defBulkActionQueries(AxiosService);

export const bulkActionSummaryQuery: BulkActionQueries['bulkActionSummaryQuery'] =
  queries.bulkActionSummaryQuery;

export const bulkActionSummaryInitializeQuery: BulkActionQueries['bulkActionSummaryInitializeQuery'] =
  queries.bulkActionSummaryInitializeQuery;
